import { queryClient } from "~/plugins/vue-query";
import { documentsService } from "~/utils/api/documentsService";
import { getProjectId } from "~/utils/getProjectId";

export default defineNuxtRouteMiddleware(async () => {
  const projectId = getProjectId();

  if (projectId) {
    queryClient.fetchQuery({
      queryKey: ["documents"],
      queryFn: () =>
        documentsService.getDocuments({
          client_project_id: projectId,
        }),
    });
  }
});
